import { createSlice } from '@reduxjs/toolkit';
import reducer from './reducer';

const initialState = {
  list: [], // List<PipelineGroupDto> from GET /api/pipelines
  filter: {},
  viewItem: undefined,
};

export default createSlice({
  name: 'pipeline',
  initialState,
  reducers: reducer,
});
